import { Button } from 'primereact/button';
import { toast } from 'sonner';

interface CopyButtonProps {
    value: string;
    label?: string;
    successMessage?: string;
    errorMessage?: string;
    size?: 'small' | 'normal' | 'large';
}

/** Копирует переданное значение. */
export const CopyButton = (
    {
        value,
        label,
        successMessage = 'Скопировано в буфер обмена',
        errorMessage = 'Не удалось скопировать',
        size = 'small',
    }: CopyButtonProps
) => {
    /** Копирует значение в буфер обмена */
    const handleCopy = async (e: React.MouseEvent): Promise<void> => {
        e.stopPropagation();
        try {
            await navigator.clipboard.writeText(value);
            toast.success(successMessage);
        } catch {
            toast.error(errorMessage);
        }
    };

    return (
        <Button
            type="button"
            icon="pi pi-copy"
            size={size === 'normal'
                ? undefined
                : size
            }
            text
            severity="secondary"
            onClick={(event) => void handleCopy(event)}
            aria-label={label || 'Копировать'}
            tooltip={label || 'Копировать'}
            tooltipOptions={{ position: 'top' }}
        />
    );
};
